import { render, staticRenderFns } from "./SearchAndAddMembersModal.vue?vue&type=template&id=5a7f2aba"
import script from "./SearchAndAddMembersModal.vue?vue&type=script&lang=js"
export * from "./SearchAndAddMembersModal.vue?vue&type=script&lang=js"
import style0 from "./SearchAndAddMembersModal.vue?vue&type=style&index=0&id=5a7f2aba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports